export const ACCOUNT_INFO = '/accountinfo';
export const USERS = '/users';
export const TEAMS = '/teams';
export const TEAMS_SUCCESS = '/teams/success';
export const TEAMS_CALL_GROUP = '/teams/call-group';
export const TEAMS_CALL_GROUP_PHONE_NUMBER =
  '/teams/call-group/:groupId/:team/phone-number';
export const TEAMS_CALL_GROUP_CALL_DISTRIBUTION =
  '/teams/call-group/:groupId/:team/call-distribution';
export const TEAMS_CALL_GROUP_VOICEMAIL =
  '/teams/call-group/:groupId/:team/voicemail';
export const TEAMS_CALL_GROUP_FORWARDING =
  '/teams/call-group/:groupId/:team/forwarding';
export const TEAMS_MESSAGING = '/teams/messaging/:groupId/:team';
export const ROLES = '/roles';
export const MESSAGING = '/messaging';
export const CONTACT_CENTER = '/contactcenter';

export const RESET_DATA_STATUS = '/reset-data-status';

export const ADVANCED_ROLES = '/advancedroles';
export const ADVANCED_ROLES_CREATE = '/advancedroles/create/role';
export const ADVANCED_ROLES_CREATE_PERMISSIONS =
  '/advancedroles/create/role/permissions/:slug';
export const ADVANCED_ROLES_ROLE_ID = '/advancedroles/:actionType/:roleId';
export const ADVANCED_ROLES_ROLE_ID_PERMISSIONS =
  '/advancedroles/:actionType/:roleId/permissions/:slug';
export const PERMISSIONS = '/permissions/:slug';

export const EMAIL = '/email';

export const LICENSING = '/licensing';
export const LICENSES = '/licensing/licenses';
export const DATA_IMPORT = '/data-import';
export const THANK_YOU = '/users/thankyou';
export const SCHEDULES = '/schedules';
